<template>
  <div class="vacancy">
    <template v-if="departure.bus && departure.bus.available">
      <p class="p">
        Podes cambiar pasajeros de butaca, reservar butacas nuevas, agregar menores ¡o
        ambas! Al finalizar, presioná "continuar" para avanzar.
      </p>
      <div class="vacancy_content">
        <div class="vacancy_buses">
          <div class="bus bus-example mx-auto">
            <div class="bus-seats mb-1 p-1 d-flex justify-content-around text-center">
              <div
                v-for="(seat, i) in refs"
                :key="i"
                class="p-2"
              >
                <seat-icon :fill="seat.hex" />
                <div>{{ seat.text }}</div>
              </div>
            </div>
          </div>
          <bus
            :map="bus"
            class="d-flex"
            @seat="toogle"
            ref="bus"
          />
        </div>
        <div class="vacancy_form">
          <div class="mb-4">
            <div
              class="d-flex mb-2"
              v-for="passenger in passengers"
              :key="passenger.id"
            >
              <div class="mr-4">
                <component :is="passenger.status == 'revocate' ? 's' : 'span'">
                  {{ passenger.alt }}
                </component>
                <small v-if="passenger.main">
                  {{ passenger.type_es }} (Titular)
                </small>
                <small v-else>{{ passenger.type_es }}</small>
              </div>
              <div class="ml-auto">
                <btn
                  size="xs"
                  @click="revocate(passenger)"
                  v-if="
                    passenger.status != 'revocate' &&
                      travelers.adults.length > 1
                  "
                >
                  CANCELAR
                </btn>
                <btn
                  size="xs"
                  v-if="passenger.seat_id"
                  @click="relocate(passenger)"
                >
                  CAMBIAR ASIENTO
                </btn>
              </div>
            </div>
          </div>
          <transition-group
            name="list"
            tag="div"
          >
            <template v-if="departure.minors">
              <div
                class="vacancy_form_group"
                :key="2"
              >
                <span class="pr-4">
                  INFOAS (HASTA {{ departure.minors.infoas.age }} AÑOS)
                  <b>SIN SERV.</b>
                </span>
                <counter
                  v-model="infoas"
                  :incrementer="infoas < max.infoas"
                  :max="max.infoas"
                />
              </div>
              <div
                class="vacancy_form_group"
                :key="3"
              >
                <span class="pr-4">
                  INFOAS (HASTA {{ departure.minors.infoas.age }} AÑOS)
                  <b>CON SERV.</b>
                </span>
                <counter
                  v-model="infoascb"
                  :incrementer="infoascb < max.infoascb"
                  :max="max.infoascb"
                />
              </div>
              <div
                class="vacancy_form_group"
                v-if="!!departure.minors.kids"
                :key="4"
              >
                <span
                  class="pr-4"
                >MENORES (DE {{ departure.minors.infoas.age }} A
                  {{ departure.minors.kids.age }} AÑOS)</span>
                <counter
                  v-model="kids"
                  :incrementer="kids < max.kids"
                  :max="max.kids"
                />
              </div>
            </template>
            <div
              class="vacancy_form_group"
              :key="6"
            >
              <span class="pr-4">CANTIDAD DE PASAJEROS</span>
              <span class="label label-violet">
                {{
                  Object.values(travelers).reduce(
                    (count, pax) => count + pax.length,
                    0
                  )
                }}
              </span>
            </div>
            <div :key="7">
              <small
                class="d-block"
                v-if="travelers.adults.length"
              >
                {{ travelers.adults.length }}
                {{ PASSENGER_TYPES.adults.text }}
              </small>
              <small
                class="d-block"
                v-if="travelers.kids.length"
              >
                {{ travelers.kids.length }} {{ PASSENGER_TYPES.kids.text }}
              </small>
              <small
                class="d-block"
                v-if="travelers.infoascb.length"
              >
                {{ travelers.infoascb.length }}
                {{ PASSENGER_TYPES.infoascb.text }}
              </small>
              <small
                class="d-block"
                v-if="travelers.infoas.length"
              >
                {{ travelers.infoas.length }}
                {{ PASSENGER_TYPES.infoas.text }}
              </small>
            </div>
          </transition-group>
        </div>
      </div>
      <div class="align-items-center d-flex justify-content-end mb-3">
        <span
          class="mr-2"
          v-if="noseat > 0"
        >PASAJEROS SIN BUTACAS {{ noseat }}</span>
        <btn
          size="xs"
          color="orange"
          @click.prevent="next"
          :disabled="!travelers.adults.length || noseat > 0"
        >
          CONTINUAR
        </btn>
        <btn
          size="xs"
          @click="close"
        >
          VOLVER
        </btn>
      </div>
    </template>
    <h1
      v-else
      class="txt-center"
    >
      Comuniquese con nosotros para consultar la disponibiladad del micro.
    </h1>
  </div>
</template>
<script>
import Btn from '@/components/Btn'
import SeatIcon from '@/components/SeatIcon'
import Bus from './components/Bus'
import swal from 'sweetalert2'
import Counter from '@/components/Counter'
import { SEAT_STATUS, PASSENGER_TYPES } from '@/constans'
import { clone, UID } from '@/utils'
import { PASSENGERS, SEATS, STEP, REVOCATIONS } from '@/store/mutations'

const fill = status =>
  SEAT_STATUS[status] && SEAT_STATUS.freezed.str != status
    ? SEAT_STATUS[status].hex
    : SEAT_STATUS.reserved.hex
const refs = [SEAT_STATUS.free, SEAT_STATUS.assigned, SEAT_STATUS.reserved, SEAT_STATUS.picked]

const Pax = a => ({
  id: a.id || '',
  revocation_id: a.revocation_id || '',
  departure_id: a.departure_id || '',
  main: a.main || 0,
  type: a.type || '',
  type_es: a.type_es || '',
  reservation_id: a.reservation_id || '',
  boarding_id: a.boarding_id || '',
  seat_id: a.seat_id || '',
  seat_categ: a.seat_categ || 0,
  seat_categ_str: a.seat_categ_str || '',
  seat_price: a.seat_price || '',
  price: a.price || '',
  fee: a.fee || '',
  fee_es: a.fee_es || '',
  alt: a.alt || '',
  ident: a.ident || '',
  name: a.name || '',
  surname: a.surname || '',
  insurance_outland: a.insurance_outland || '',
  insurance_old: a.insurance_old || '',
  birthday: a.birthday || '',
  gender: a.gender || '',
  nationality: a.nationality || '',
  areacode: a.areacode || '',
  tel: a.tel || '',
  notes: a.notes || '',
  rooms: a.rooms || [],
  status: a.status || ''
})

export default {
  components: { SeatIcon, Btn, Bus, Counter },

  computed: {
    max () {
      const seats =
				this.picked.length - this.passengers.filter(p => p.status == 'relocate').length
      const kids = this.departure.minors && this.departure.minors.kids
        ? Math.min(this.departure.minors.kids.max, seats - this.infoascb)
        : 0
      const infoascb = this.departure.minors && this.departure.minors.infoas
        ? Math.min(this.departure.minors.infoas.max - this.infoas, seats - this.kids)
        : 0
      const infoas = this.departure.minors
        ? this.departure.minors.infoas.max - this.infoascb
        : 0
      return { kids, infoascb, infoas }
    },
    travelers () {
      const passengers = clone(this.passengers) || []
      let pax = passengers.filter(p => p.status != 'revocate').length + 1
      const len =
				this.picked.length -
				passengers.filter(
				  p => p.type == PASSENGER_TYPES.adults.str && p.status === 'relocate'
				).length -
				this.kids -
				this.infoascb
      const adults = passengers
        .filter(p => p.status != 'revocate' && p.type == PASSENGER_TYPES.adults.str)
        .concat(
          Array.from(Array(len > 0 ? len : 0).keys()).map(x => {
            pax = pax + x
            return Pax({
              alt: 'PASAJERO ' + pax,
              status: 'create',
              type: PASSENGER_TYPES.adults.str,
              type_es: PASSENGER_TYPES.adults.text
            })
          })
        )
      if (!adults.some(p => p.main) && adults[0]) {
        adults[0].main = 1
      }

      const kids = passengers
        .filter(p => !p.status && p.type == PASSENGER_TYPES.kids.str)
        .concat(
          Array.from(Array(this.kids).keys()).map(x => {
            pax = pax + x
            return Pax({
              alt: 'PASAJERO ' + pax,
              status: 'create',
              type: PASSENGER_TYPES.kids.str,
              type_es: PASSENGER_TYPES.kids.text
            })
          })
        )

      const infoascb = passengers
        .filter(p => !p.status && p.type == PASSENGER_TYPES.infoascb.str)
        .concat(
          Array.from(Array(this.infoascb).keys()).map(x => {
            pax = pax + x
            return Pax({
              alt: 'PASAJERO ' + pax,
              status: 'create',
              type: PASSENGER_TYPES.infoascb.str,
              type_es: PASSENGER_TYPES.infoascb.text
            })
          })
        )

      const infoas = passengers
        .filter(p => !p.status && p.type == PASSENGER_TYPES.infoas.str)
        .concat(
          Array.from(Array(this.infoas).keys()).map(x => {
            pax = pax + x
            return Pax({
              alt: 'PASAJERO ' + pax,
              status: 'create',
              type: PASSENGER_TYPES.infoas.str,
              type_es: PASSENGER_TYPES.infoas.text
            })
          })
        )

      return {
        adults,
        kids,
        infoascb,
        infoas
      }
    },
    departure () {
      return this.$store.state.modify.departure
    },
    reservation () {
      return this.$store.state.modify.reservation
    },
    noseat () {
      return (
        this.$store.state.modify.passengers.reduce(
          (count, { status }) => (status == 'relocate' ? count + 1 : count),
          this.infoascb + this.kids
        ) - this.picked.length
      )
    },
    bus () {
      return Object.values(clone(this.departure.bus.map)).map(layer => {
        layer.layout = layer.layout.map(row =>
          row
            .map(col => this.seating[col] || col)
            .map(seat => {
              if (typeof seat === 'object') {
                seat.fill = fill(seat.status)
                seat.passenger = null

                if (this.picked.includes(seat.id)) {
                  seat.fill = SEAT_STATUS.picked.hex
                }

                if (this.passengers.some(p => p.seat_id == seat.id)) {
                  seat.fill = SEAT_STATUS.picked.hex
                  seat.passenger = this.passengers.find(p => p.seat_id == seat.id)
                }
              }
              return seat
            })
        )
        return layer
      })
    }
  },

  methods: {
    next () {
      this.$store.commit(
        'modify/' + REVOCATIONS,
        this.passengers
          .filter(p => p.status == 'revocate')
          .map(passenger => {
            passenger.tmp_id = UID()
            return passenger
          })
      )

      var travelers = Object.values(this.travelers)
        .reduce((passengers, travelers) => passengers.concat(travelers), [])
        .map(passenger => {
          passenger.departure_id = this.departure.id
          passenger.reservation_id = this.reservation.id
          passenger.fee = ''
          passenger.fee_es = ''
          passenger.rooming = null
          passenger.seat_price = null
          passenger.tmp_id = UID()

          return passenger
        })

      if (!travelers.some(p => p.type == PASSENGER_TYPES.adults.str)) {
        swal({ text: 'Es necesario al menos 1 pasajero adulto.', type: 'danger' })
        return
      }

      this.$store.commit('modify/' + PASSENGERS, travelers)
      this.$store.commit(
        'modify/' + SEATS,
        Object.values(this.seating).filter(seat => this.picked.includes(seat.id))
      )
      this.$store.commit('modify/' + STEP, 'rates')
      this.$emit('goto', 'Rates')
    },
    close () {
      this.$router
        .push({
          name: 'reservation_passengers',
          params: { id: this.reservation.id }
        })
        .then(() => {
          this.$store.dispatch('modify/CLOSE')
        })
    },
    revocate (passenger) {
      const passengers = this.passengers.map(pax => {
        if (pax.id == passenger.id) {
          if (this.seating[pax.seat_id]) {
            this.$set(this.seating[pax.seat_id], 'status', SEAT_STATUS.free.str)
          }
          pax.seat_id = null
          pax.status = 'revocate'
        }
        return pax
      })

      this.$store.commit('modify/' + PASSENGERS, passengers)
      this.passengers = passengers
    },
    relocate (passenger) {
      const passengers = this.passengers.map(pax => {
        if (pax.id == passenger.id) {
          this.$set(this.seating[pax.seat_id], 'status', SEAT_STATUS.free.str)
          pax.seat_id = null
          pax.seat_categ = null
          pax.seat_categ_str = null
          pax.status = 'relocate'
        }
        return pax
      })

      this.$store.commit('modify/' + PASSENGERS, passengers)
      this.passengers = passengers
    },
    toogle (id) {
      if (
        !this.seating[id] ||
				![SEAT_STATUS.free.str, SEAT_STATUS.assigned.str, SEAT_STATUS.picked.str].includes(
				  this.seating[id].status
				)
      ) {
        swal({ text: 'El asiento no está disponible o no es valido.', type: 'warning' })
      } else {
        if (this.picked.includes(id)) {
          this.seating[id].status = SEAT_STATUS.free.str
          this.picked.splice(this.picked.indexOf(id), 1)
        } else {
          this.picked.push(id)
        }
      }
    }
  },

  data () {
    const seating = clone(this.$store.state.modify.departure.bus.seating)
    const passengers = clone(this.$store.state.modify.reservation.passengers)
    const picked = Object.values(seating)
      .filter(s => s.status === SEAT_STATUS.picked.str)
      .map(s => s.id)

    return {
      PASSENGER_TYPES,
      passengers,
      picked,
      seating,
      refs,
      infoas: 0,
      infoascb: 0,
      kids: 0
    }
  }
}
</script>
